// extracted by mini-css-extract-plugin
export var columnList = "_dt-0";